import { DataRetriever } from '../retrievers/dataRetriever';

export const getPlaces = (retriever: DataRetriever, city: string) => retriever.getPlaces(city);

export const getCircuits = (retriever: DataRetriever, city: string) => retriever.getCircuits(city);
